module.exports = __webpack_public_path__ + "static/blog-splash-5-thumbnail-6a684b9766a6b02b8d44c00782464dae.jpg";